import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { LOAN_SECTION_KEYS } from "../loan.constants";

import { rows as sectionLoanAdditionalAdvancesRows } from "./section-loan-additional-advances-rows";
import { rows as sectionLoanEscrowReserveRows } from "./section-loan-escrow-reserve-rows";

const nullData = {
  stylename: "Work Sans /  16 Regular",
  fontFamily: "Work Sans",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "19px",
  letterSpacing: "0em",
  textAlign: "center",
  textColor: "#7d8084"
};

export class LoanAdvancesAndReserves extends Component {
  drawDataAdditionalAdvances(data) {
    if (data.additionalAdvances) {
      if (data.additionalAdvances.additionalAdvanceAllocations ||
        data.additionalAdvances.noticeForAdvance ||
        data.additionalAdvances.drawFrequency ||
        data.additionalAdvances.drawThresholdInterval ||
        data.additionalAdvances.drawConditions ||
        data.additionalAdvances.requiredEquity ||
        data.additionalAdvances.completion ||
        data.additionalAdvances.covenants ||
        data.additionalAdvances.restorationRetainage ||
        data.additionalAdvances.developmentFee ||
        data.additionalAdvances.budgetCostOverruns ||
        data.additionalAdvances.changeOrders ||
        data.additionalAdvances.misc) {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionLoanAdditionalAdvancesRows} data={data} />;
      }

      return (<p style={nullData}>Data has not been entered for this section.</p>);
    }

    return (<p style={nullData}>Data has not been entered for this section.</p>);
  }

  drawDataEscrowReserve(data) {
    if (data.covenants) {
      if (data.covenants.taxReserve ||
        data.covenants.insuranceReserve ||
        data.covenants.taxInsuranceReserve ||
        data.covenants.taxInsuranceReserveAccount ||
        data.covenants.replacementReserve ||
        data.covenants.replacementReserveAccount ||
        data.covenants.repairReserve ||
        data.covenants.repairReserveAccount ||
        (data.repairCompletionDeadline && data.repairCompletionDeadline.length > 0) ||
        data.covenants.tilcReserves ||
        data.covenants.tilcReservesMisc ||
        data.covenants.goodNewsMoneyDrawn ||
        data.covenants.ffeReserve ||
        data.covenants.ffeReserveAccount ||
        data.covenants.capExReserves ||
        data.covenants.capExReservesMisc ||
        (data.capExCompletionDeadline && data.capExCompletionDeadline.length > 0) ||
        data.covenants.capExReservesDrawn ||
        data.covenants.shortfallReserve ||
        data.covenants.shortfallReserveMisc ||
        data.covenants.operatingAccount ||
        data.covenants.interestRateCapReserve ||
        data.covenants.interestRateCapReserveMisc ||
        data.covenants.interestReserve ||
        data.covenants.interestReserveMisc ||
        data.covenants.minCashDeposit ||
        data.covenants.escrowAccountsMisc) {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionLoanEscrowReserveRows} data={data} />;
      }

      return (<p style={nullData}>Data has not been entered for this section.</p>);
    }

    return (<p style={nullData}>Data has not been entered for this section.</p>);
  }

  render() {
    const { data, history, loanId, enableEditButton, eventHandlers, ...other } = this.props;
    if (!data) {
      return null;
    }

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Advances and Reserves",
            key: LOAN_SECTION_KEYS.ADVANCES_AND_RESERVES,
            isTitleGroup: true
          },
          {
            title: "Additional Advances",
            key: LOAN_SECTION_KEYS.SECTION_ADDITIONAL_ADVANCES,
            isExpandable: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.SECTION_ADDITIONAL_ADVANCES}`),
            sections: [
              this.drawDataAdditionalAdvances(data)
            ],
            references: data.references,
            eventHandlers,
            referencedFieldPath: "loans.additionalAdvances.header",
            referenceStyles: { marginLeft: "20px" }
          },
          {
            title: "Escrow/Reserve",
            key: LOAN_SECTION_KEYS.SECTION_ESCROW_RESERVE,
            isExpandable: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.SECTION_ESCROW_RESERVE}`),
            sections: [
              this.drawDataEscrowReserve(data)
            ],
            references: data.references,
            eventHandlers,
            referencedFieldPath: "loans.covenants.header",
            referenceStyles: { marginLeft: "20px" }
          }
        ]}
      />
    );
  }
}
